import {notification} from 'antd'

import {CloseIcon, CloseCircleIcon, CheckCircleIcon} from 'common/components'

export const showErrorNotification = (message: string) =>
  notification.error({
    message,
    closeIcon: <CloseIcon />,
    icon: <CloseCircleIcon width={24} height={24} />,
  })

export const showSuccessNotification = (message: string) =>
  notification.success({
    message,
    closeIcon: <CloseIcon />,
    icon: <CheckCircleIcon width={24} height={24} />,
  })
